import React from "react";
import { Navigate, Routes, Route } from "react-router-dom";
import { Role } from "../../app/util/role";

import ProtectedRoutes from "./ProtectedRoutes";

import LoginForm from "../../features/user/LoginForm";
import ResetPasswordForm from "../../features/user/ResetPasswordForm";


import Configuration from "../../features/configuration/DashboardConfiguration";
import DashboardCompany from "../../features/configuration/company/company/DashboardCompany";
import DashboardUsers from "../../features/configuration/company/usersCompany/DashboardUsers";
import DashboardNewBroker from "../../features/configuration/broker/newBroker/DashboardNewBroker";
import DashboardSeller from "../../features/configuration/seller/DashboardSeller";
import DashboardBroker from "../../features/configuration/broker/DashboardBroker";
import DashboardClient from "../../features/clients/DashboardClient";
import DashBoardEditClient from "../../features/clients/clients/DashBoardEditClient";
import DashboardGraphic from "../../features/clients/clients/graphics/DashboardGraphic";
import DashboardReport from "../../features/reports/DashboardReport";
import DashboardSettlementReport from "../../features/reports/settlement/DashboardSettlementReport";
import DashboardBrokerReport from "../../features/reports/broker/DashboardBrokerReport";
import DashboardTenantReport from "../../features/reports/tenant/DashboardTenantReport";


import { sectionsConfiguration } from "../../app/util/breadcrumbOptions";

const RoutesComponent = () => {
  const match = { path: "/home" };

  return (
    <Routes>
        <Route
          path={`${match.path}/Configuration/DashboardUsers`}
          element={
            <ProtectedRoutes>
              <DashboardUsers sections={sectionsConfiguration} />
            </ProtectedRoutes>
          }
        />
        <Route
          path={`${match.path}/Configuration/DashboardCompany`}
          element={
            <ProtectedRoutes>
              <DashboardCompany sections={sectionsConfiguration} />
            </ProtectedRoutes>
          }
        />
        <Route
          path={`${match.path}/Client/DashboardEditClient/:id`}
          element={
            <ProtectedRoutes>
              <DashBoardEditClient />
            </ProtectedRoutes>
          }
        />
        <Route
          path={`${match.path}/Client/DashboardNewClient/:id`}
          element={
            <ProtectedRoutes>
              <DashBoardEditClient />
            </ProtectedRoutes>
          }
        />
        <Route
          path={`${match.path}/Client/DashboardGraphic/:id`}
          element={
            <ProtectedRoutes>
              <DashboardGraphic />
            </ProtectedRoutes>
          }
        />
        <Route
          path={`${match.path}/Client/DashboardClient`}
          element={
            <ProtectedRoutes>
              <DashboardClient sections={[]} />
            </ProtectedRoutes>
          }
        />
        <Route
          path={`${match.path}/Report/DashboardReportTenant`}
          element={
            <ProtectedRoutes>
              <DashboardTenantReport />
            </ProtectedRoutes>
          }
        />

        <Route
          path={`${match.path}/Report/DashboardReportBroker`}
          element={
            <ProtectedRoutes expectedRole={Role.Sudo}>
              <DashboardBrokerReport />
            </ProtectedRoutes>
          }
        />
        <Route
          path={`${match.path}/Report/DashboardReportSettlement`}
          element={
            <ProtectedRoutes expectedRole={Role.Sudo}>
              <DashboardSettlementReport />
            </ProtectedRoutes>
          }
        />
        <Route
          path={`${match.path}/Configuration/Broker/DashboardNewBroker/:id`}
          element={
            <ProtectedRoutes expectedRole={Role.Sudo}>
              <DashboardNewBroker />
            </ProtectedRoutes>
          }
        />
        <Route
          path={`${match.path}/Configuration/Broker/DashboardEditBroker/:id`}
          element={
            <ProtectedRoutes expectedRole={Role.Sudo}>
              <DashboardNewBroker />
            </ProtectedRoutes>
          }
        />
        <Route
          path={`${match.path}/Configuration/Broker/DashboardBroker`}
          element={
            <ProtectedRoutes expectedRole={Role.Sudo}>
              <DashboardBroker sections={sectionsConfiguration} />
            </ProtectedRoutes>
          }
        />
        <Route
          path={`${match.path}/Configuration/Seller/DashboardSeller`}
          element={
            <ProtectedRoutes expectedRole={Role.Sudo}>
              <DashboardSeller sections={sectionsConfiguration} />
            </ProtectedRoutes>
          }
        />


        <Route
          path={`${match.path}/Report`}
          element={
            <ProtectedRoutes>
              <DashboardReport />
            </ProtectedRoutes>
          }
        />
        <Route
          path={`${match.path}/Configuration`}
          element={
            <ProtectedRoutes>
              <Configuration />
            </ProtectedRoutes>
          }
        />

        <Route path="/users/reset/:resetToken" element={<ResetPasswordForm />} />
        <Route path="/" element={<LoginForm />} />
        <Route path="*" element={<Navigate to="/home/Client/DashboardClient" replace />} />

    </Routes>
  );
};

export default RoutesComponent;
